export default __webpack_public_path__ + "static/media/dubai-maritime-city.f23d5f61.png";